// TODO: 不確定會不會再改
export const INIT_FORM_VALUES = {
  recipients: {
    plans: [],
    members: [],
  },
  transactionPoints: {
    deduction: null,
    topUp: null,
  },
  expiration: null,
};

// TODO: 從這以下為假資料，需改成真實資料後刪除
export const PLAN_OPTIONS = [
  {
    label: '黑卡會員',
    value: '黑卡會員',
  },
  {
    label: '金卡會員',
    value: '金卡會員',
  },
  {
    label: '銀卡會員',
    value: '銀卡會員',
  },
  {
    label: '銅卡會員',
    value: '銅卡會員',
  },
  {
    label: '鑽卡會員',
    value: '鑽卡會員',
  },
  {
    label: '白金卡會員',
    value: '白金卡會員',
  },
];

export const MEMBER_OPTIONS = [
  {
    label: '0987878787 朴敘俊',
    value: '0987878787 朴敘俊',
  },
  {
    label: '0966777666 河智苑',
    value: '0966777666 河智苑',
  },
  {
    label: '0933999111 韓佳人',
    value: '0933999111 韓佳人',
  },
  {
    label: '0955787321 孔劉',
    value: '0955787321 孔劉',
  },
  {
    label: '0951663774 申敏兒',
    value: '0951663774 申敏兒',
  },
  {
    label: '0946215368 玄彬',
    value: '0946215368 玄彬',
  },
  {
    label: '0912345678 鄭智薰',
    value: '0912345678 鄭智薰',
  },
  {
    label: '0923456789 金秀賢',
    value: '0923456789 金秀賢',
  },
  {
    label: '0934567890 李敏鎬',
    value: '0934567890 李敏鎬',
  },
  {
    label: '0967890123 李鍾碩',
    value: '0967890123 李鍾碩',
  },
  {
    label: '0989012345 宋仲基',
    value: '0989012345 宋仲基',
  },
];
